import lozad from 'lozad'
  
window.addEventListener('load', function() {

  var postsList = document.querySelector('.js-posts-list');

  if(!postsList)
    return;

  window.paged = 1;
  var cpt = postsList.dataset.cpt;
  var maxnumpages = (document.querySelector('.js-posts-list-item')) ? 
    document.querySelector('.js-posts-list-item').getAttribute('data-maxnumpages') : 0;
  var submitButton = document.querySelector('.js-filter-submit');
  var selectCategory = document.querySelector('.js-select-category');
  var selectLocation = document.querySelector('.js-select-location');
  var loadMoreButton = document.querySelector('.js-load-more');
  var categorySlug  = 'categorie';
  var locationSlug  = 'localisation';
  var currentCategory = getUrlParameter(categorySlug) ? getUrlParameter(categorySlug) : selectCategory.options[selectCategory.selectedIndex].value;
  var currentLocation = getUrlParameter(locationSlug) ? getUrlParameter(locationSlug) : selectLocation.options[selectLocation.selectedIndex].value;
  const observer = lozad();
  var xhr;
  var loadPostsAjaxUrl;
  
  var basename = location.origin;
  switch (cpt) {
  case 'news':
    basename += '/actualites/';
    break;
  }

  // On submitButton click, empty List & load a new List
  submitButton.addEventListener('click', function(){
    // Disabled during ajax load
    if(postsList.classList.contains('loading'))
      return;

    currentCategory = selectCategory.value;
    currentLocation = selectLocation.value;
    postsList.innerHTML = '';
    loadMoreButton.classList.add('visually-hidden');
    window.paged = 1;
    rewriteURL();
    loadPosts();

  });

  // On Load More Click, increment paged & load Courses
  loadMoreButton.addEventListener('click', function(){

    // Disabled during ajax load
    if(loadMoreButton.classList.contains('visually-hidden'))
      return;

    window.paged++;

    loadPosts();
  });

  // Show previous Page & Load hidden next Page with filters
  function loadPosts(){

    // Disable filterSubmit & loadMoreButton during ajax load
    loadMoreButton.classList.add('visually-hidden');
    postsList.classList.add('loading');
    
    // console.log(window.paged);
    // console.log(cpt);

    // Ajax Request
    xhr = new XMLHttpRequest();
    loadPostsAjaxUrl = ajax_js.ajaxurl
      + '?action=load_'+cpt
      + '&page=' + window.paged
      + '&categorie='+currentCategory
      + '&localisation='+currentLocation;
    xhr.open('GET', loadPostsAjaxUrl);
    xhr.onload = function() {
      if (xhr.status === 200) {

        // Add page results to list
        postsList.innerHTML += xhr.responseText;

        // Lazy Load Observer
        observer.observe();

        // On 1st page, set maxnumpage
        if(window.paged == 1)
          maxnumpages = (document.querySelector('.js-posts-list-item')) ?
            document.querySelector('.js-posts-list-item').getAttribute('data-maxnumpages') : 0;

        // Show LoadMoreButton if more Pages
        if(window.paged < maxnumpages)
          loadMoreButton.classList.remove('visually-hidden');

        // Remove loading class
        postsList.classList.remove('loading');
      }
    };
    xhr.send();
  }

  // Rewrite current page URL according to current filters
  function rewriteURL() {

    var newUrl = basename;

    if(currentCategory || currentLocation) {
      var currentCategoryVal = currentCategory ? currentCategory : 'toute-categorie';
      var currentLocationVal = currentLocation ? currentLocation : 'toute-localisation';
      newUrl += currentCategoryVal + '/' + currentLocationVal;
    }

    window.history.pushState("", "", newUrl);
  }

  // Get parameter value from an URL parameter key
  function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam)
        return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }

});
